export default __webpack_public_path__ + "static/media/Hats05.b7ea2bce.png";